var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.313 382C357.555 378.189 351.895 369.548 351.895 360.001V280H24C10.75 280 0 269.25 0 256C0 242.75 10.75 232 24 232H351.895V152C351.895 142.453 357.555 133.812 366.312 129.998C375.066 126.187 385.262 127.921 392.25 134.406L504.324 238.406C514.559 247.906 514.559 264.095 504.324 273.593L392.25 377.595C385.262 384.08 375.066 385.814 366.313 382Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLong);
export default __webpack_public_path__ + "static/media/right-long.c128b65955f66524829d5ddc748d9c85.svg";
export { ForwardRef as ReactComponent };